import React, { useEffect, useState } from 'react';
import Api from '../../../Api';
import sendRequest from '../../../helpers/sendRequest';
import MyLoading from '../../../components/MyLoading';

function TemplatePhotoPreview({ templateId }) {
  const [photo, setPhoto] = useState(null);
  const [loading, setLoading] = useState(true);

  const getPhoto = async () => {
    const data = await sendRequest({
      request: Api.getSingleTemplatePhoto,
      payload: { id: templateId },
      warnErrorText: 'while getting single template photo',
      setLoading,
    });

    if (data?.status === 'ok') {
      setPhoto(data.templatePhoto);
    }
  };

  useEffect(() => {
    getPhoto().then();
  }, [templateId]);

  return (
    <div style={{
      width: '148px', height: '148px', borderRadius: '12px', overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center',
    }}
    >
      {loading ? <MyLoading /> : (
        <img style={{ width: '100%', height: '100%' }} src={Api.url + photo?.photo?.preview_url} alt="photo" />
      )}
    </div>
  );
}

export default TemplatePhotoPreview;
